(() => {
  const init = root => {
    if (root.dataset.eventPricesReady) return;
    root.dataset.eventPricesReady = 'true';
    const endsAt = Date.parse(root.dataset.eventEndsAt);
    const note = root.querySelector('[data-event-price-note]');
    const expire = () => {
      if (Date.now() < endsAt) return;
      root.querySelectorAll('[data-event-price]').forEach(price => {
        price.querySelector('[data-event-offer]').hidden = true;
        price.querySelector('[data-event-standard]').hidden = false;
      });
      if (note) note.textContent = root.dataset.eventEndedNote;
    };
    expire();
    const observer = new MutationObserver(expire);
    const observe = () => {
      const grid = root.querySelector('[data-model-grid]');
      if (root.isConnected && grid) observer.observe(grid, {childList:true});
    };
    observe();
    if (Date.now() < endsAt) window.setTimeout(expire, Math.min(endsAt - Date.now(), 2147483647));
    window.addEventListener('pageshow', () => {
      observe();
      expire();
    });
    document.addEventListener('visibilitychange', expire);
    window.addEventListener('pagehide', () => observer.disconnect());
  };
  const initAll = () => document.querySelectorAll('[data-subinats-models]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once:true});
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

